export default __webpack_public_path__ + "images/f174aedee9751bb42363c114c713e149.png";